var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-button",
    class: [{
      'filter-button_active': _vm.active
    }],
    attrs: {
      "data-e2e": "catalog-filter-checkbox__mobile"
    },
    on: {
      "click": function ($event) {
        _vm.isFilterSelected ? null : _vm.$emit('show-filter-modal');
      }
    }
  }, [_c('div', {
    staticClass: "filter-button__filter-icon",
    on: {
      "click": function ($event) {
        return _vm.$emit('show-filter-modal');
      }
    }
  }), _vm._v(" "), _vm.active ? _c('div', {
    staticClass: "filter-button__selected-filters",
    on: {
      "click": function ($event) {
        return _vm.$emit('show-filter-modal');
      }
    }
  }, [_c('div', {
    staticClass: "filter-button__reset",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('reset');
      }
    }
  }, [_vm._v("\n      Сбросить\n    ")]), _vm._v(" "), _vm._l(_vm.filters, function (filter) {
    return _c('div', {
      key: filter.name,
      staticClass: "filter-button__selected-filter-group"
    }, [_c('span', {
      staticClass: "filter-button__selected-filter-prop fz-10 grey-text"
    }, [_vm._v(_vm._s(filter.name))]), _vm._v(" "), _c('span', {
      staticClass: "filter-button__selected-filter-val fz-13"
    }, [_vm._v(_vm._s(_vm.selectedFilters(filter.list)))])]);
  })], 2) : _c('div', {
    staticClass: "filter-button__modal-icon"
  }, [_vm._v("\n    Фильтры по категории\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }